export const REVENUE_IE_URL = 'https://www.revenue.ie';
export const GOV_UK_URL = 'https://www.gov.uk/stamp-duty-land-tax/residential-property-rates';
export const WILSON_NESBITT_LINK =
  'https://wilson-nesbitt.com/property/residential-property/legal-fees-quotation/?utm_source=propertynews.com&utm_medium=referral&utm_campaign=listings';
